/* global bootstrap */
window.addEventListener('DOMContentLoaded', () => {
  function copyPageCanonicalUrlToClipboard(event) {
    event.preventDefault();
    const buttonUrl = event.currentTarget.dataset.href;
    const canonicalUrlElement = document.querySelector("meta[property='og:url']");
    const urlToCopy = buttonUrl || canonicalUrlElement?.getAttribute('content');
    if (urlToCopy && navigator.clipboard) {
      navigator.clipboard.writeText(urlToCopy).then(
        () => {
          showCopyStatusMessage(event.target, true);
        },
        () => {
          showCopyStatusMessage(event.target, false);
        }
      );
    } else {
      showCopyStatusMessage(event.target, false);
    }
  }

  function showCopyStatusMessage(element, isSuccess) {
    const toastId = element.dataset.toastId ? element.dataset.toastId : element.parentElement.dataset.toastId;
    const toastEl = document.querySelector(`#${toastId}`);
    toastEl.querySelector(`.toast-body`).innerHTML = isSuccess
      ? 'Link successfully copied!'
      : 'Failed to copy article link to clipboard.';
    if (isSuccess) {
      toastEl.classList.remove('bg-danger');
      toastEl.classList.add('bg-success');
    } else {
      toastEl.classList.remove('bg-success');
      toastEl.classList.add('bg-danger');
    }
    const toast = bootstrap.Toast.getOrCreateInstance(toastEl);
    toast.show();
  }

  document.querySelectorAll('.social-share-copy-article-url-link').forEach((socialShareCopyLink) => {
    socialShareCopyLink.addEventListener('click', copyPageCanonicalUrlToClipboard);
  });
});
